const INITIAL_STATE = {
  esperandoSolicitacao: false,
  edicaoPeriodo: false,
  edicaoRemuneracao: false,
  existeAlteracaoVinculos: false,
  alerta: {},
  formVinculo: {
    nomeVinculo: "Período Adicionado Manualmente",
    dataInicio: "",
    dataFim: "",
    tipoVinculoRelacaoTrabalhista: "EMPREGADO",
    remuneracoes: []
  },
  vinculoSelecionado: {
    nomeVinculo: "Período Adicionado Manualmente",
    dataInicio: "",
    dataFim: "",
    tipoVinculoRelacaoTrabalhista: "",
    //tipoRegimeEspecialRelacaoTrabalhista: "",
    relacaoTrabalhistaTO: {
      empregadorTO: {},
      listaRemuneracoesTO: [],
    },
  },
  modalMensagem: {
    show: false,
    message: ''
  }
};

const MESSAGE_REMOVE_VINCULO_SUCESSO = 'Período excluído com sucesso.';
const MESSAGE_ADICIONAR_VINCULO_SUCESSO = 'Período adicionado com sucesso.';
const MESSAGE_EDITAR_PERIODO_VINCULO_SUCESSO = 'Período alterado com sucesso.';
const MESSAGE_EDITAR_REMUNERACAO_VINCULO_SUCESSO = 'Remunerações alteradas com sucesso.';

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "REQUERIMENTO_VINCULOS_CIDADAO_ALERTA_VALIDACAO":
      return {
        ...state,
        esperandoSolicitacao: false,
        alerta: { message: action.payload, severity: "warning" },
      };
    case "REQUERIMENTO_VINCULOS_CIDADAO_ERRO_VALIDACAO":
      return {
        ...state,
        esperandoSolicitacao: false,
        alerta: { message: action.payload, severity: "error" },
      };
    case "REQUERIMENTO_VINCULOS_CIDADAO_LIMPAR_MSG_VALIDACAO":
      return {
        ...state,
        alerta: {},
      };
    case "REQUERIMENTO_VINCULOS_CIDADAO_MENSAGEM_SUCESSO": {
      return {
        ...state,
        alerta: { message: action.payload, severity: "success" },
      };
    }
    case "REQUERIMENTO_VINCULOS_CIDADAO_CLOSE_MESSAGE":
      return { ...state, alerta: {} };
    case 'REQUERIMENTO_VINCULOS_SELECIONAR_DETALHAR':
      return { ...state, vinculoSelecionado: action.payload, alerta: {} }
    case 'REQUERIMENTO_VINCULOS_CIDADAO_REMOVER_SUCESSO':
      return {
        ...state,
        esperandoSolicitacao: false,
        existeAlteracaoVinculos: true,
        alerta: { message: MESSAGE_REMOVE_VINCULO_SUCESSO, severity: 'success' }
      };
    case 'REQUERIMENTO_VINCULOS_CIDADAO_SET_EDICAO_PERIODO':
      return { ...state, edicaoPeriodo: !state.edicaoPeriodo }
    case 'REQUERIMENTO_VINCULOS_CIDADAO_SET_EDICAO_REMUNERACAO':
        return { ...state, edicaoRemuneracao: !state.edicaoRemuneracao }
    case "REQUERIMENTO_VINCULOS_INICIAR_CADASTRAR_VINCULO": {
      const { existeAlteracaoVinculos } = state;
      return { ...state, ...INITIAL_STATE, existeAlteracaoVinculos };
    }
    case "REQUERIMENTO_VINCULOS_INICIAR_EDITAR_PERIODO_VINCULO": {
      return {
        ...state,
        edicaoPeriodo: true,
        formVinculo: action.payload
      }
    }
    case "REQUERIMENTO_VINCULOS_CANCELAR_EDITAR_PERIODO_VINCULO": {
      return {
        ...state,
        edicaoPeriodo: false,
        formVinculo: {
          ...state.formVinculo,
          dataInicio: state.vinculoSelecionado.dataInicio,
          dataFim: state.vinculoSelecionado.dataFim,
          tipoVinculoRelacaoTrabalhista: state.vinculoSelecionado.tipoVinculoRelacaoTrabalhista,
        }
      }
    }
    case "REQUERIMENTO_VINCULOS_SET_VINCULO_TO": {
      const { field, value } = action.payload;
      return { ...state, vinculoSelecionado: { ...state.vinculoSelecionado, [field]: value } };
    }
    case "REQUERIMENTO_VINCULOS_SET_FORM_VINCULO_TO": {
      const { field, value } = action.payload;
      return { ...state, formVinculo: { ...state.formVinculo, [field]: value } };
    }
    case "REQUERIMENTO_VINCULOS_LIMPAR_REMUNERACOES": {
      return {
        ...state,
        vinculoSelecionado: {
          ...state.vinculoSelecionado,
          relacaoTrabalhistaTO: {
            ...state.vinculoSelecionado.relacaoTrabalhistaTO,
            listaRemuneracoesTO: [],
          },
        },
      };
    }
    case "REQUERIMENTO_VINCULOS_CANCELAR_ADICIONAR_VINCULO": {
      const { existeAlteracaoVinculos } = state;
      return { ...state, ...INITIAL_STATE, existeAlteracaoVinculos };
    }
    case "REQUERIMENTO_VINCULOS_CANCELAR_EDITAR_VINCULO": {
      return { ...state, vinculoSelecionado: action.payload, edicaoPeriodo: false, edicaoRemuneracao: false, alerta: {} };
    }
    case "REQUERIMENTO_VINCULOS_CONFIRMAR_PREENCHER_REMUNERACOES_EM_LOTE": {
      return {
        ...state,
        alerta: {},
        vinculoSelecionado: { ...action.payload }
      };
    }
    case "REQUERIMENTO_VINCULOS_CONFIRMAR_ADICIONAR_PERIODO_VINCULO": {
      return {
        ...state,
        vinculoSelecionado: action.payload,
        edicaoRemuneracao: true,
        alerta: {}
      };
    }
    case "REQUERIMENTO_VINCULOS_CONFIRMAR_ADICIONAR_VINCULO": {
      return {
        ...state,
        ...INITIAL_STATE,
        existeAlteracaoVinculos: true,
        modalMensagem: {
          ...state.modalMensagem,
          show: true,
          message: MESSAGE_ADICIONAR_VINCULO_SUCESSO
        }
      };
    }
    case "REQUERIMENTO_VINCULOS_CONFIRMAR_EDITAR_PERIODO_VINCULO": {
      return {
        ...state,
        ...INITIAL_STATE,
        existeAlteracaoVinculos: true,
        vinculoSelecionado: action.payload,
        modalMensagem: {
          ...state.modalMensagem,
          message: MESSAGE_EDITAR_PERIODO_VINCULO_SUCESSO,
          show: true
        }
      };
    }
    case "REQUERIMENTO_VINCULOS_CONFIRMAR_EDITAR_REMUNERACAO_VINCULO": {
      return {
        ...state,
        ...INITIAL_STATE,
        existeAlteracaoVinculos: true,
        vinculoSelecionado: action.payload,
        modalMensagem: {
          ...state.modalMensagem,
          message: MESSAGE_EDITAR_REMUNERACAO_VINCULO_SUCESSO,
          show: true
        }
      };
    }
    case "REQUERIMENTO_VINCULOS_CIDADAO_LIMPAR_ALTERACAO": {
      return {
        ...state,
        existeAlteracaoVinculos: false,
        alerta: {},
      };
    }
    case "REQUERIMENTO_VINCULOS_BUSCA_EXTRATO_INICIALIZADO":
      return {
        ...state,
        esperandoSolicitacao: true,
      };
    case "REQUERIMENTO_VINCULOS_BUSCA_EXTRATO_FINALIZADO":
      return {
        ...state,
        esperandoSolicitacao: false,
      };
    case "REQUERIMENTO_VINCULOS_SET_SHOW_MODAL_MENSAGEM":
      return {
        ...state,
        modalMensagem: {
          ...state.modalMensagem,
          show: action.payload
        }
      }
    default:
      return state;
  }
};
